import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'metatrader-pswd-popup',
    templateUrl: './metatrader-pswd-popup.component.html',
    styleUrls: ['./metatrader-pswd-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, MatDialogModule]
})
export class MetatraderPswdPopupComponent {}
